module.exports = __webpack_public_path__ + "img/restaurant-view-tabs02.d2401b15.svg";